<style lang="stylus">
    .adbox-topbar
        position relative
        display flex
        padding-right 20px
        align-items center
        height 100%
        white-space nowrap
        cursor pointer
        object-fit contain
            img
                width 100%
                cursor pointer
</style>

<template>
    <div class="adbox-topbar" v-if="showTopbar">
        <img :src="activityData.imgUrl" alt="" @click="openLink(activityData.linkUrl)" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class ADTopbar extends Vue {
        @Prop()
        activityData;
        @Prop()
        activityTime;
        @Prop()
        activityKey;
        @Prop()
        isCheckLog;

        get userInfo() {
            return this.$store.state.userInfo;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        // 检验是否启用，是否处于活动时间，是否会员屏蔽，是否手动关闭
        get showTopbar() {
            return this.$store.state.showTopbar && this.isCheckLog;
        }
        openLink(url) {
            let userInfo = "";
            if (this.userInfo && this.userInfo.user_id) {
                userInfo = `&custom=${encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })))}`;
            }
            if (this.internal) {
                url = `${url}?catalogues=Edrawmaxbuysuccess&source=banner${userInfo}`;
                this.$track("clicksale", "click", `saletype:banner` + `;type:${this.isPC ? "desktop" : "online"}`);
            }

            let newTab = window.open("about:blank");
            newTab.location.href = url;
        }
        checkLog() {
            if (this.$validateLogin(false)) {
                this.$emit("updateActivity");
            } else {
                this.$bus.$on("loginSucc", () => {
                    this.$emit("updateActivity");
                });
            }
        }
        mounted() {
            this.checkLog();
            this.$bus.$on("changeLang", this.checkLog);
        }
        beforeDestroy() {
            this.$bus.$off("loginSucc");
            this.$bus.$off("changeLang");
        }
    }
</script>
